export const InvoicePaths = {
  SEARCH: '/invoice/search',
  DETAIL: '/invoice/detail',
  DATE_RESULTS: '/invoice/date-results',
  TRANSACTION_HISTORY: '/invoice/transaction-history',
};
